package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLCanvasElement
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import waldo.sankan.lineamunicipalkmp.web.components.IncidentsTable
import kotlin.js.Date
import kotlin.js.json
import kotlin.math.roundToInt

private fun Int.percentOf(total: Int): Int {
    if (this <= 0 || total <= 0) return 0
    return (this.toDouble() / total * 100).roundToInt()
}

@Composable
private fun StatCard(label: String, value: String, color: CSSColorValue = Color.black) {
    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); padding(16.px) } }) {
        Span({ style { fontSize(28.px); fontWeight("bold"); color(color) } }) { Text(value) }
        Span({ style { fontSize(14.px); color(Color("#666666")) } }) { Text(label) }
    }
}

@Composable
private fun EstadisticasFilterSection(
    uiState: AdminPanelUiState,
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    // Variables de estado locales para manejar los inputs de fecha
    var fechaInicioStr by remember { mutableStateOf("") }
    var fechaFinStr by remember { mutableStateOf("") }

    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Row);
            gap(24.px);
            padding(32.px);
            backgroundColor(Color("#e9ecef"));
            borderRadius(8.px);
            alignItems(AlignItems.Center);
        }
    }) {

        // Filtro de Período
        FilterDropdown(
            label = "Período:",
            selectedValue = uiState.filtroMesEstadisticas,
            options = listOf("ANUAL") + uiState.mesesDisponibles,
            onValueChanged = { viewModel.onFiltroMesEstadisticasChanged(it) },
            optionDisplayNames = (listOf("ANUAL" to "Resumen Anual") + uiState.mesesDisponibles.map {
                val (year, month) = it.split("-")
                it to Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
            }).toMap()
        )

        // --- ¡NUEVA SECCIÓN DE FILTRO POR RANGO DE FECHAS! ---
        Span({
            style {
                fontWeight("bold");
                marginLeft(16.px) } })
        { Text("Ó Filtrar por Rango:") }

        Label(forId = "fechaInicio") { Text("Desde:") }
        Input(type = InputType.Date) {
            id("fechaInicio")
            value(fechaInicioStr)
            onInput { fechaInicioStr = it.value }
            style {
                padding(8.px);
                borderRadius(4.px);
                border(1.px, LineStyle.Solid, Color("#cccccc")) }
        }

        Label(forId = "fechaFin") { Text("Hasta:") }
        Input(type = InputType.Date) {
            id("fechaFin")
            value(fechaFinStr)
            onInput { fechaFinStr = it.value }
            style {
                padding(8.px);
                borderRadius(4.px);
                border(1.px, LineStyle.Solid, Color("#cccccc")) }
        }




        // --- ¡EL SOLDADO INVISIBLE QUE EMPUJA! ---
        Div({
            style {
                flex(1) // ¡ORDEN DE OCUPAR TODO EL ESPACIO LIBRE!
            }
        })




        Button(attrs = {
            onClick {
                if (fechaInicioStr.isNotBlank() && fechaFinStr.isNotBlank()) {
                    // --- ¡OPERACIÓN TIEMPO UNIVERSAL! ---
                    // Usamos Date.parse() que es más explícito y devuelve Double.
                    val fechaInicioDouble = Date.parse("${fechaInicioStr}T00:00:00.000Z")
                    val fechaFinDouble = Date.parse("${fechaFinStr}T23:59:59.999Z")

                    // ¡ORDEN DE FUEGO CON EL CALIBRE CORRECTO (DOUBLE)!
                    viewModel.onFiltroRangoFechasDelitosChanged(fechaInicioDouble, fechaFinDouble)
                }
            }
            style {
                padding(14.px);
                fontSize(16.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#FB8C00"));
                borderRadius(8.px);
                cursor("pointer")
            }

            // --- ¡CORRECCIÓN DEL ERROR 'disabled'! ---
            if (fechaInicioStr.isBlank() || fechaFinStr.isBlank()) {
                disabled() // Así se aplica el atributo 'disabled' correctamente
            }
        }) {
            Text("Aplicar Filtro")
        }

        Button(attrs = {
            onClick { onBack() }
            style {
                padding(14.px);
                fontSize(16.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#FB8C00"));
                borderRadius(8.px); cursor("pointer") }
        }) { Text("Volver al Panel") }

        // Botón de Exportación PDF
        Button(attrs = {
            onClick {
                js("""
                    var jsPDF = window.jspdf.jsPDF;
                    var doc = new jsPDF('p', 'mm', 'a4');
                    var element = document.getElementById('contenido-informe');
                    
                    html2canvas(element, {
                        scale: 2,
                        useCORS: true,
                        logging: false,
                        backgroundColor: '#1976D2'
                    }).then(function(canvas) {
                        var imgData = canvas.toDataURL('image/png');
                        var imgProps = doc.getImageProperties(imgData);
                        var pdfWidth = doc.internal.pageSize.getWidth();
                        var pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                        
                        var heightLeft = pdfHeight;
                        var position = 0;
                        
                        doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                        heightLeft -= doc.internal.pageSize.getHeight();
                        
                        while (heightLeft >= 0) {
                            position = heightLeft - pdfHeight;
                            doc.addPage();
                            doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                            heightLeft -= doc.internal.pageSize.getHeight();
                        }
                        
                        doc.save('Informe_Seguridad_LineaMunicipal.pdf');
                    });
                """)
            }
            style {
                padding(14.px);
                fontSize(16.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#4CAF50"));
                borderRadius(8.px);
                cursor("pointer");
                marginLeft(8.px)
            }
        }) {
            Text("Exportar PDF")
        }
    }
}

@Composable
fun InformeSeguridadScreen(
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    val uiState by viewModel.uiState.collectAsState()
    val stats = uiState.estadisticasDelitos // ¡LEEMOS LOS STATS DEL ESTADO REACTIVO!


    // --- VISTA PRINCIPAL DEL PANEL (TABLA E INCIDENCIAS) ---
    Div({
        style {
            display(DisplayStyle.Flex);
            width(100.percent);
            backgroundColor(Color("#1976D2"));
            property("border-bottom",
                "2px solid #1565C0")
        }
    }) {
        // Logo y Título
        Div({
            style {
                width(15.percent);
                display(DisplayStyle.Flex);
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center);
                paddingRight(16.px);
                paddingLeft(16.px);
                boxSizing("border-box")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex);
                    flexDirection(FlexDirection.Column);
                    alignItems(AlignItems.Center);
                    gap(8.px) } }) {
                Img(src = "logo_icon.svg",
                    attrs = {
                        style { height(120.px) } })
                H2({
                    style { fontSize(24.px);
                        color(Color.white);
                        margin(0.px);
                        property("text-shadow",
                            "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                    Span({
                        style {
                            fontWeight("normal") } })
                    { Text("Linea") }
                    Span({
                        style {
                            fontWeight("bold") } })
                    { Text("Muni") }
                }
                P(attrs = { attr("translate", "no");
                    style { fontSize(16.px);
                        color(Color("#FB8C00"));
                        fontWeight("bold");
                        letterSpacing(1.px);
                        margin(0.px) } })
                { Text("SMART CITY") }
            }
        }

        // Panel de Control y Filtros
        Div({
            style {
                width(85.percent);
                padding(32.px);
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column);
                gap(24.px);
                boxSizing("border-box")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex);
                    justifyContent(JustifyContent.SpaceBetween);
                    alignItems(AlignItems.Center);
                }
            }) {
                H1({
                    style {
                        color(Color.white);
                        fontSize(32.px);
                        fontWeight(700);
                        paddingTop(30.px)
                        margin(0.px);
                        flex(1);
                        textAlign("center")
                    }
                }) { Text("INFORME SEGURIDAD CIUDADANA") }
            }


            EstadisticasFilterSection(uiState = uiState, onBack = onBack, viewModel = viewModel)
       }
    }


        // --- CONTENIDO PRINCIPAL ---
        Div({
            id("contenido-informe")
            style {
                paddingRight(32.px);
                paddingLeft(32.px)
                backgroundColor(Color("#1976D2"));
            } }) {

            // --- ¡LA GUARDIA DE SEGURIDAD DEFINITIVA! ---
            if (uiState.isLoading) {
                P { Text("Calculando informe...") }
            } else if (stats == null) {
                // Esto se muestra si, después de filtrar, no hay datos
                Div({
                    style {
                        padding(24.px);
                        textAlign("center");
                        backgroundColor(Color("#1976D2"));
                        borderRadius(12.px) } }) {
                    P { Text("No se encontraron delitos para el período seleccionado.") }
                }
            } else {
                // ¡SI HAY DATOS, MOSTRAMOS TODO EL INFORME!
                val totalDelitos = stats.desglosePorGrupo.values.sumOf { it.total }

                // --- TARJETA PRINCIPAL DEL INFORME ---
                Div({
                    style {
                        backgroundColor(Color("#1976D2"));
                        borderRadius(12.px);
                        paddingBottom(32.px);
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {

                    // TÍTULO DINÁMICO
                    H2({
                        style {
                            fontSize(24.px);
                            color(Color.white);
                            marginTop(0.px);
                            marginBottom(24.px);
                            property("border-bottom", "1px solid #e0e0e0");
                            paddingBottom(16.px) } }) {
                        val periodoSeleccionado = uiState.filtroMesEstadisticas?.let {
                            if (it == "ANUAL") "Resumen Anual"
                            else {
                                val (year, month) = it.split("-")
                                Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL",
                                    options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
                            }
                        } ?: "Informe"
                        Text(periodoSeleccionado)
                    }

                    // --- BARRA DE RESUMEN (ESTILO ESPEJO ESTADÍSTICAS GENERALES) ---
                    Div({
                        style {
                            display(DisplayStyle.Flex);
                            justifyContent(JustifyContent.SpaceAround);
                            alignItems(AlignItems.Center);
                            padding(24.px);
                            backgroundColor(Color("#fafafa"));
                            borderRadius(12.px);
                            marginBottom(32.px);
                            property("box-shadow", "inset 0px 2px 4px rgba(0,0,0,0.05)")
                        }
                    }) {
                        StatCard(label = "Total", value = stats.resumenGeneral.total.toString())
                        StatCard(label = "Solucionadas", value = stats.resumenGeneral.solucionado.toString(), color = Color("#4CAF50"))
                        StatCard(label = "En Proceso", value = stats.resumenGeneral.enProceso.toString(), color = Color("#FFC107"))
                        StatCard(label = "Rechazadas", value = stats.resumenGeneral.rechazado.toString(), color = Color("#F44336"))
                        StatCard(label = "Verificadas", value = stats.resumenGeneral.verificado.toString(), color = Color("#3F51B5"))
                    }




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    // --- CONTENIDO PRINCIPAL ---
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(24.px) // Espacio vertical entre cada una de las grandes tarjetas blancas
                }
            }) {





                // --- FILA 1: ANÁLISIS DE CANTIDADES ABSOLUTAS ---

                Div({
                    style {
                        backgroundColor(Color.white)
                        borderRadius(12.px)
                        padding(24.px)
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    }
                }) {
                    H2({ style { fontSize(24.px); color(Color("#1976D2")); marginTop(0.px); marginBottom(24.px); property("border-bottom", "1px solid #e0e0e0"); paddingBottom(16.px) } }) {
                        Text("Resumen por Cantidades")
                    }

                    // --- ESTRUCTURA DE COLUMNAS 40/60 ---
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Row)
                            gap(24.px)
                            alignItems(AlignItems.Start)
                        }
                    }) {
                        // --- COLUMNA IZQUIERDA (40%) TABLA ---
                        Div({ style { flexBasis(40.percent) } }) {
                            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(14.px) } }) {
                                Thead({ style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        Th({ style { padding(12.px) } }) { Text("Grupo") }
                                        Th({ style { padding(12.px) } }) { Text("Total") }
                                        Th({ style { padding(12.px); color(Color("#4CAF50")) } }) { Text("Solucionadas") }
                                        Th({ style { padding(12.px); color(Color("#FFC107")) } }) { Text("En Proceso") }
                                        Th({ style { padding(12.px); color(Color("#F44336")) } }) { Text("Rechazadas") }
                                        Th({ style { padding(12.px); color(Color("#3F51B5")) } }) { Text("Verificadas") }
                                    }
                                }
                                Tbody {
                                    stats.desglosePorGrupo.entries.sortedByDescending { it.value.total }.forEach { (grupo, desglose) ->
                                        Tr {
                                            Td({ style { padding(12.px); fontWeight(700) } }) { Text(grupo) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(desglose.total.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(desglose.solucionado.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(desglose.enProceso.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(desglose.rechazado.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(desglose.verificado.toString()) }
                                        }
                                    }
                                }
                            }
                        }

                        // --- COLUMNA DERECHA (60%) GRÁFICOS ---
                        Div({
                            style {
                                flexBasis(60.percent)
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                gap(32.px) // Espacio ENTRE los dos gráficos
                            }
                        }) {
                            // GRÁFICO #1: Torta de Distribución
                            Div({
                                style {
                                    flex(1)
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(32.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text("Distribuci\u00F3n") }
                                Div({
                                    style {
                                        flex(1);
                                        width(100.percent);
                                        height(300.px); position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("pieChart-Grupos-Cantidades") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("pieChart-Grupos-Cantidades") as? HTMLCanvasElement
                                        var chart: Chart? = null
                                        if (canvas != null) {
                                            val data = json("labels" to stats.desglosePorGrupo.keys.toTypedArray(), "datasets" to arrayOf(json("data" to stats.desglosePorGrupo.map { it.value.total }.toTypedArray(), "backgroundColor" to stats.desglosePorGrupo.keys.map { nombreGrupo -> TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(TipificacionesRepositoryCEAD.listaNombresDeDelitos.find { TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(it)?.grupo == nombreGrupo } ?: "")?.colorHex ?: "#808080" }.toTypedArray())))
                                            val options = json("responsive" to true, "maintainAspectRatio" to false, "plugins" to json("legend" to json("position" to "right")))
                                            chart = Chart(canvas.getContext("2d"), json("type" to "pie", "data" to data, "options" to options))
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }

                            // GRÁFICO #2: Barras de Composición
                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(32.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px) } })
                                { Text("Composición") }
                                Div({
                                    style {
                                        width(100.percent);
                                        height(500.px);
                                        position(Position.Relative) } }) {
                                    Canvas(attrs = { id("barChart-Grupos-Cantidades") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("barChart-Grupos-Cantidades") as? HTMLCanvasElement
                                        var chart: Chart? = null
                                        if (canvas != null) {
                                            val labels = stats.desglosePorGrupo.keys.toTypedArray()
                                            val chartData = json("labels" to labels, "datasets" to arrayOf(json("label" to "Solucionado", "data" to stats.desglosePorGrupo.map { it.value.solucionado }.toTypedArray(), "backgroundColor" to "#4CAF50"), json("label" to "En Proceso", "data" to stats.desglosePorGrupo.map { it.value.enProceso }.toTypedArray(), "backgroundColor" to "#FFC107"), json("label" to "Rechazado", "data" to stats.desglosePorGrupo.map { it.value.rechazado }.toTypedArray(), "backgroundColor" to "#F44336")))
                                            val options = json("responsive" to true, "maintainAspectRatio" to false, "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))), "y" to json("stacked" to true))
                                            chart = Chart(canvas.getContext("2d"), json("type" to "bar", "data" to chartData, "options" to options))
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }





                // --- FILA 2: ANÁLISIS DE PORCENTAJES (RESTAURADA Y RECONSTRUIDA) ---
                Div({
                    style {
                        backgroundColor(Color.white)
                        borderRadius(12.px)
                        padding(24.px)
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    }
                }) {
                    H2({
                        style {
                            fontSize(24.px);
                            color(Color("#1976D2"));
                            marginTop(0.px);
                            marginBottom(24.px);
                            property("border-bottom", "1px solid #e0e0e0"); paddingBottom(16.px) } }) {
                        Text("Análisis por Porcentaje de Cumplimiento")
                    }

                    // --- ¡APLICAMOS LA MISMA ESTRUCTURA VICTORIOSA 40/60! ---
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Row)
                            gap(24.px)
                            alignItems(AlignItems.Start)
                        }
                    }) {
                        // COLUMNA IZQUIERDA (40%) TABLA
                        Div({ style { flexBasis(40.percent) } }) {
                            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(14.px) } }) {
                                Thead({ style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        Th({ style { padding(12.px) } }) { Text("Grupo") }
                                        Th({ style { padding(12.px) } }) { Text("% del Total") }
                                        Th({ style { padding(12.px) } }) { Text("% En Proceso") }
                                        Th({ style { padding(12.px) } }) { Text("% Solucionado") }
                                        Th({ style { padding(12.px) } }) { Text("% Rechazado") }
                                    }
                                }
                                Tbody {
                                    stats.desglosePorGrupo.entries.sortedByDescending { it.value.total }.forEach { (grupo, desglose) ->
                                        Tr {
                                            Td({ style { padding(12.px); fontWeight(700) } }) { Text(grupo) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.total.percentOf(totalDelitos)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.enProceso.percentOf(desglose.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.solucionado.percentOf(desglose.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.rechazado.percentOf(desglose.total)}%") }
                                        }
                                    }
                                }
                            }
                        }

                        // ¡COLUMNA DERECHA (60%) PARA GRÁFICOS APILADOS RESTAURADA!
                        Div({
                            style {
                                flexBasis(60.percent)
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                gap(32.px)
                            }
                        }) {
                            // GRÁFICO #1: Torta de Distribución
                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px)
                                    }
                                }) { Text("Distribuci\u00F3n (%)") }

                                Div({
                                    style {
                                        flex(1);
                                        width(100.percent);
                                        height(800.px);
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("pieChart-Grupos-Porcentajes") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("pieChart-Grupos-Porcentajes") as? HTMLCanvasElement
                                        var chart: Chart? = null
                                        if (canvas != null) {
                                            val data = json("labels" to stats.desglosePorGrupo.keys.toTypedArray(), "datasets" to arrayOf(json("data" to stats.desglosePorGrupo.map { it.value.total.percentOf(totalDelitos) }.toTypedArray(), "backgroundColor" to stats.desglosePorGrupo.keys.map { nombreGrupo -> TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(TipificacionesRepositoryCEAD.listaNombresDeDelitos.find { TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(it)?.grupo == nombreGrupo } ?: "")?.colorHex ?: "#808080" }.toTypedArray())))
                                            val options = json("responsive" to true, "maintainAspectRatio" to false, "plugins" to json("legend" to json("position" to "right")))
                                            chart = Chart(canvas.getContext("2d"), json("type" to "pie", "data" to data, "options" to options))
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }

                            // GRÁFICO #2: Barras de Cumplimiento
                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px)
                                    }
                                })
                                { Text("Cumplimiento (%)") }
                                Div({
                                    style {
                                        width(100.percent);
                                        height(500.px);
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("barChart-Grupos-Porcentajes") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("barChart-Grupos-Porcentajes") as? HTMLCanvasElement
                                        var chart: Chart? = null
                                        if (canvas != null) {
                                            val labels = stats.desglosePorGrupo.keys.toTypedArray()
                                            val chartData = json("labels" to labels, "datasets" to arrayOf(json("label" to "Solucionado", "data" to stats.desglosePorGrupo.map { it.value.solucionado }.toTypedArray(), "backgroundColor" to "#4CAF50"), json("label" to "En Proceso", "data" to stats.desglosePorGrupo.map { it.value.enProceso }.toTypedArray(), "backgroundColor" to "#FFC107"), json("label" to "Rechazado", "data" to stats.desglosePorGrupo.map { it.value.rechazado }.toTypedArray(), "backgroundColor" to "#F44336")))
                                            val options = json("responsive" to true, "maintainAspectRatio" to false, "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))), "y" to json("stacked" to true))
                                            chart = Chart(canvas.getContext("2d"), json("type" to "bar", "data" to chartData, "options" to options))
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }






                // --- FILA 3: DETALLE POR DELITO ESPECÍFICO (RESTAURADA Y COMPLETA) ---
                Div({ style { backgroundColor(Color.white); borderRadius(12.px); padding(24.px); property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {
                    H2({ style { fontSize(24.px); color(Color("#1976D2")); marginTop(0.px); marginBottom(24.px); property("border-bottom", "1px solid #e0e0e0"); paddingBottom(16.px) } }) {
                        Text("Detalle por Delito Específico")
                    }
                    Div({ style { display(DisplayStyle.Flex); gap(24.px);
                        alignItems(AlignItems.Stretch) } }) {
                        // Columna 1 (50%): Tabla de Delitos
                        Div({ style { flex(1) } }) {
                            Div({ style { maxHeight(800.px);
                                overflowY("auto") } }) {
                                Table({
                                    style { width(100.percent);
                                        property("border-collapse", "collapse");
                                        fontSize(14.px) } }) {
                                    Thead({
                                        style {
                                            backgroundColor(Color("#eef2f5")) } }) {
                                        Tr { Th({
                                            style { padding(12.px) } })
                                            { Text("Delito") };
                                            Th({
                                                style { padding(12.px) } })
                                            { Text("Total") };
                                            Th({
                                                style { padding(12.px) } })
                                            { Text("En Proceso") };
                                            Th({
                                                style {padding(12.px) } })
                                            { Text("Solucionado") };
                                            Th({
                                                style { padding(12.px) } })
                                            { Text("Rechazado") } }
                                    }
                                    Tbody {
                                        val delitosMostrados = stats.desglosePorDelito.entries.filter { it.value.total > 0 }.sortedByDescending { it.value.total }
                                        delitosMostrados.forEach { (delito, desglose) ->
                                            Tr {
                                                Td({ style { padding(12.px); fontWeight(700) } }) { Text(delito) }
                                                Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.total} (${desglose.total.percentOf(totalDelitos)}%)") }
                                                Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.enProceso} (${desglose.enProceso.percentOf(desglose.total)}%)") }
                                                Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.solucionado} (${desglose.solucionado.percentOf(desglose.total)}%)") }
                                                Td({ style { padding(12.px); textAlign("center") } }) { Text("${desglose.rechazado} (${desglose.rechazado.percentOf(desglose.total)}%)") }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // Columna 2 (50%): Gráfico Barras de Delitos
                        Div({ style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(16.px) } }) {
                            H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text("Composición de Estados") }
                            Div({ style { width(100.percent); height(100.percent); minHeight(800.px); position(Position.Relative) } }) {
                                Canvas(attrs = { id("barChart-Delitos") })
                                DisposableEffect(stats) {
                                    val canvas = document.getElementById("barChart-Delitos") as? HTMLCanvasElement
                                    var chart: Chart? = null
                                    if (canvas != null) {
                                        val delitosMostrados = stats.desglosePorDelito.entries.filter { it.value.total > 0 }.sortedByDescending { it.value.total }.reversed()
                                        val labels = delitosMostrados.map { it.key }.toTypedArray()
                                        val chartData = json("labels" to labels, "datasets" to arrayOf(
                                            json("label" to "Solucionado", "data" to delitosMostrados.map { it.value.solucionado }.toTypedArray(), "backgroundColor" to "#4CAF50"),
                                            json("label" to "En Proceso", "data" to delitosMostrados.map { it.value.enProceso }.toTypedArray(), "backgroundColor" to "#FFC107"),
                                            json("label" to "Rechazado", "data" to delitosMostrados.map { it.value.rechazado }.toTypedArray(), "backgroundColor" to "#F44336")
                                        ))
                                        val options = json(
                                            "responsive" to true,
                                            "maintainAspectRatio" to false,
                                            "indexAxis" to "y",
                                            "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))),
                                            "plugins" to json("title" to json("display" to true, "text" to "Composición de Estados por Delito"))
                                        )
                                        chart = Chart(canvas.getContext("2d"), json("type" to "bar", "data" to chartData, "options" to options))
                                    }
                                    onDispose { chart?.destroy() }
                                }
                            }
                        }
                    }
                }



                // Dentro de InformeSeguridadScreen.kt

// ... (después de las tarjetas de estadísticas)

                H3({ style { marginTop(32.px); color(Color("#333333")) } }) {
                    Text("Detalle de Incidencias Incluidas en el Informe")
                }
                Div({ style { maxHeight(600.px); overflowY("auto") } }) {
                    // ¡CONEXIÓN DIRECTA CON EL MOTOR DE ESTADÍSTICAS!
                    // La tabla ahora consume exactamente la misma lista que generó los KPIs
                    IncidentsTable(
                        incidencias = uiState.incidenciasInformeSeguridad,
                        onIncidenciaClick = { viewModel.onIncidenciaSelected(it) }
                    )
                }
            }
        }
    }
}}

